import { render } from "./PeopleSanz.vue?vue&type=template&id=043f7ef4"
import script from "./PeopleSanz.vue?vue&type=script&lang=js"
export * from "./PeopleSanz.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__